import { BankError } from '#modules/Bank/Bank.types'
import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../../fluxStandardAction'

export type StartCloseConsumerDataPullSessionAction = FluxStandardAction<
	'transactionClientApp/consumerPullSessions/close',
	{
		shouldClearBudgetAndDebtData: boolean
	}
>
type CloseConsumerDataPullSessionSucceededAction = FluxStandardAction<
	'transactionClientApp/consumerPullSessions/closeSucceeded',
	null
>
type CloseConsumerDataPullSessionFailedAction =
	FluxStandardFailureAction<'transactionClientApp/consumerPullSessions/closeFailed'>

export type CloseConsumerDataPullSessionAction =
	| StartCloseConsumerDataPullSessionAction
	| CloseConsumerDataPullSessionSucceededAction
	| CloseConsumerDataPullSessionFailedAction

export function closeConsumerDataPullSession(
	shouldClearBudgetAndDebtData: boolean,
): StartCloseConsumerDataPullSessionAction {
	return {
		type: 'transactionClientApp/consumerPullSessions/close',
		payload: { shouldClearBudgetAndDebtData },
	}
}

export function closeConsumerDataPullSessionSucceeded(): CloseConsumerDataPullSessionSucceededAction {
	return {
		type: 'transactionClientApp/consumerPullSessions/closeSucceeded',
		payload: null,
	}
}

export function closeConsumerDataPullSessionFailed(
	closeConsumerDataPullSessionError: BankError,
): CloseConsumerDataPullSessionFailedAction {
	return {
		type: 'transactionClientApp/consumerPullSessions/closeFailed',
		error: true,
		payload: closeConsumerDataPullSessionError,
	}
}
